import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from 'react-router-dom';

import "./style.css";

import UseSidebar from './../../UseSidebar';
//import SideBarDataComp from "./SideBarData";
//import useSidebar from '../../UseSidebar';
import { getTokenInfo } from './../../UseToken';

import { language } from './Language';

function Sidebar() {
    //const showSidebar = () => setSidebar(!sidebar)
    // //console.log(sidebar);
    // //console.log(showSidebar);

    //PRINT ROUTE
    const { pathname } = useLocation();
    //console.log(pathname);
    //const { sideBarData, getSidebar } = useSidebar();
    const [sideBarData, set_SIDE_BAR] = useState([])
    //console.log(props);

    const [lang, set_lang] = useState('pt');

    useEffect(() => {
        UseSidebar().getSidebar(getTokenInfo().profile).then(v => { set_SIDE_BAR(v); })

        set_lang(localStorage.getItem('lang'))

        return () => { }
    }, [])

    //const SideBarData = SideBarDataComp(props);
    //console.log(props)

    return (
        <div className={'sidebar left-sidebar'}>
            <div className="sidebar-menu">
                <nav className="sidebar-nav">
                    <ul id="sidebarnav" className="in">
                        {
                        sideBarData.map((item, key) => {
                            //props.sidebar_info.map((item, key) => {
                            if(item.allow === false) {
                                return ''
                            }
                            // PARA O CASO DE UMA CLASSNAME ESPECIFICA
                            if(item.title.localeCompare('') === 0) {
                                return (
                                    <li key={key} className={item.cName}></li>
                                )
                            }
                            else {
                                if(item.submenu.length > 0 && (item.show_submenu !== undefined && item.show_submenu)) {
                                    let menuActive = false;

                                    /*if(item.path === '/estancia_config_regist'){

                                        console.log('aki aki 1')
                                        console.log('show submenu 1', item.show_submenu)
                                        console.log('item path 1', item.path)
                                        console.log('pathname 1', pathname)
                                        
                                    }*/

                                    item.submenu.map(submenu => {


                                        if(submenu.allow === false) {
                                            return ''
                                        }

                                        if(item.path.localeCompare(pathname) === 0 || submenu.path.localeCompare(pathname) === 0) {
                                            menuActive = true;
                                        }

                                        return menuActive
                                    })

                                    return (
                                        <li key={key} className={menuActive ? "sidebar-item has-submenu selected" : "sidebar-item has-submenu"}>
                                            {/*<li key={key} className={item.path.localeCompare(pathname) == 0 ? "sidebar-item selected" : "sidebar-item"}>*/}
                                            {/*{console.log('ICON>>>>>>>>>>>>', item.icon)}*/}
                                            {/*console.log('ICON B >>>>>>>>>>>>', item.icon_b)}*/}

                                            <NavLink isActive={() => [item.path].includes(pathname)} activeClassName='active' to={item.path} className={((getTokenInfo().profile === 'Autor' || getTokenInfo().profile === 'Revisor' || getTokenInfo().profile === 'Editor') && (item.path === '/autor_list' || item.path === '/editor_list' || item.path === '/revisor_list')) ? "sidebar-link" : "sidebar-link has-arrow"} >
                                                <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                {/*<span className="hide-menu">{item.title}</span>*/}
                                                <span className="hide-menu">{language[lang][item.title_lang]}</span>
                                            </NavLink>

                                            <ul area-expanded='false' className={menuActive ? "collapse first-level base-level-line in" : "collapse first-level base-level-line"}>
                                                {
                                                item.submenu.map((submenu, key_2) => {
                                                    //let submenuActive = false;

                                                    if(submenu.allow === false) {
                                                        return ''
                                                    }

                                                    /*if(pathname === '/estancia_meios_regist'){
                                                        console.log('item path 2', item.path)
                                                        console.log('sub menu 2', submenu)
                                                        console.log('sub menu path 2', submenu.path)
                                                        console.log('sub menu path base2 ', submenu.path_base)
                                                        console.log(submenu.path.localeCompare(pathname) === 0)
                                                        console.log(submenu.path.includes(submenu.path_base))
                                                    }

                                                    if((submenu.path.localeCompare(pathname) === 0) && (submenu.path.includes(submenu.path_base))) {
                                                        submenuActive = true;
                                                        //return submenuActive;
                                                    }*/

                                                    return (
                                                        <li key={key_2} className='sidebar-item'>
                                                            <NavLink isActive={() => [submenu.path].includes(pathname)} activeClassName='active' to={submenu.path} className={submenu.title.localeCompare('') === 0 ? 'd-none' : 'sidebar-link'} >
                                                                <span className={submenu.cName}></span>
                                                                {/*<span>{submenu.title}</span>*/}
                                                                <span>{language[lang][submenu.title_lang]}</span>
                                                            </NavLink>
                                                        </li>
                                                    )
                                                })
                                                }
                                            </ul>
                                        </li>
                                    )
                                }
                                //excepção para o caso o item da sidebar tenha sub menus mas eles estiverem ocultos/desabilitados
                                //vai manter na mesma as classes active e selected ao criar ou editar um novo registo
                                if(item.submenu.length > 0 && (item.show_submenu !== undefined && !item.show_submenu)) {
                                    let menuActive = false;

                                    /*if(item.path === '/estancia_meios_list'){

                                        console.log('aki aki 2 ')
                                        console.log('show submenu2 ', !item.show_submenu)
                                        console.log('item path2 ', item.submenu)
                                        //console.log('sub menu path', submenu.path)
                                    }*/

                                    item.submenu.map(submenu => {

                                        if(item.path.localeCompare(pathname) === 0 || submenu.path.localeCompare(pathname) === 0) {
                                            menuActive = true;
                                        }

                                        return menuActive
                                    })

                                    

                                    return (
                                        <li key={key} className={menuActive ? "sidebar-item selected" : "sidebar-item"}>

                                            <NavLink isActive={() => menuActive} activeClassName='active' to={item.path} className="sidebar-link" >
                                                <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                {/*<span className="hide-menu">{item.title}</span>*/}
                                                <span className="hide-menu">{language[lang][item.title_lang]}</span>
                                            </NavLink>

                                        </li>
                                    )
                                }
                                else {

                                    /*if(pathname === 'estancia_meios_regist') {
                                        console.log('aki aki 3 ')
                                        console.log('item path 3', item.path)
                                        console.log('show submenu 3', item.show_submenu)
                                        console.log('submenu length 3', item.submenu.length)
                                        console.log('pathname 3', pathname)
                                    }*/

                                    
                                    return (
                                        <li key={key} className={item.path.localeCompare(pathname) === 0 ? "sidebar-item selected" : "sidebar-item"}>
                                            <NavLink isActive={() => [item.path].includes(pathname)} activeClassName='active' to={item.path} className="sidebar-link" replace>
                                                <span className="menu-icon"><i className={"bi bi-" + item.icon}></i></span>
                                                {/*<span>{item.title}</span>*/}
                                                <span>{language[lang][item.title_lang]}</span>
                                            </NavLink>
                                        </li>
                                    )
                                }
                            }
                        })
                        }
                    </ul>
                </nav>
            </div>
        </div >
    )
}

export default Sidebar;
